'use strict';

var format = require('date-fns/format');
var constants = require('../constants.cjs');
var parsers = require('../parsers.cjs');
var getLocaleData = require('../utils/getLocaleData.cjs');
var getFormatStringForTimeRangePreset = require('./formatStrings/getFormatStringForTimeRangePreset.cjs');

function _interopDefault (e) { return e && e.__esModule ? e.default : e; }

var format__default = /*#__PURE__*/_interopDefault(format);

const formatISOTimePartInterval = (params) => {
  const {
    presetName,
    isoTimePartInterval,
    locale,
    endDateAlt = constants.DEFAULT_END_DATE_ALTERNATIVE
  } = params;
  const [fromFormatString, toFormatString] = getFormatStringForTimeRangePreset.getFormatStringForTimeRangePreset(
    presetName,
    locale
  );
  const startTime = parsers.isoTimePartToDate(isoTimePartInterval.start);
  const formattedStart = format__default(startTime, fromFormatString, {
    locale: getLocaleData(locale)
  });
  if (isoTimePartInterval.end === void 0) {
    return `${formattedStart} \u2013 ${endDateAlt}`;
  }
  const endTime = parsers.isoTimePartToDate(isoTimePartInterval.end);
  const formattedEnd = format__default(endTime, toFormatString, {
    locale: getLocaleData(locale)
  });
  return `${formattedStart} \u2013 ${formattedEnd}`;
};

module.exports = formatISOTimePartInterval;
//# sourceMappingURL=formatISOTimePartInterval.cjs.map
